import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Services.css';

function Services() {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="page-hero" style={{
        backgroundImage: 'linear-gradient(135deg, rgba(22, 33, 62, 0.5) 0%, rgba(26, 26, 46, 0.5) 100%), url(/images/services-hero-bg.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container">
          <h1>Nuestros Servicios</h1>
          <p>Soluciones integrales en recursos humanos, tecnología, asesoría y capacitación</p>
        </div>
      </section>

      {/* Recursos Humanos */}
      <section id="recursos-humanos" className="service-section">
        <div className="container">
          <div className="service-content">
            <div className="service-image">
              <img src="/images/security-guard-service.png" alt="Guardias de Seguridad" />
            </div>
            <div className="service-text">
              <span className="service-badge">Recursos Humanos</span>
              <h2>Guardias de Seguridad</h2>
              <p className="service-intro">Guardias de seguridad registrados y autorizados por Carabineros de Chile (OS10), personal uniformado, equipado con radios portátiles y capacitado según la normativa vigente.</p>
              
              <h3>Tipos de Servicio</h3>
              <div className="service-types">
                <div className="service-type-card">
                  <h4>Guardias Permanentes</h4>
                  <ul>
                    <li>Servicio 24/7 continuo</li>
                    <li>Personal fijo asignado</li>
                    <li>Supervisión constante</li>
                    <li>Reportes diarios</li>
                  </ul>
                </div>
                <div className="service-type-card">
                  <h4>Guardias Esporádicos</h4>
                  <ul>
                    <li>Eventos especiales</li>
                    <li>Refuerzos temporales</li>
                    <li>Fechas específicas</li>
                    <li>Proyectos puntuales</li>
                  </ul>
                </div>
              </div>

              <h3>Control CCTV con Analistas</h3>
              <div className="cctv-control">
                <p>Servicio de monitoreo profesional de sistemas de videovigilancia con personal capacitado para análisis en tiempo real, detección de incidentes y generación de reportes.</p>
              </div>

              <h3>Respaldo Legal y Seguros</h3>
              <ul className="advantages-list">
                <li><strong>Autorización OS10:</strong> Empresa bajo número 0805XXXXXXXX de Carabineros de Chile</li>
                <li><strong>Seguro de Responsabilidad Civil:</strong> Cobertura hasta 1.000 UF con HDI Seguros</li>
                <li><strong>Seguro de Vida:</strong> Protección para todos los trabajadores con HDI Seguros</li>
                <li><strong>Afiliación ACHS:</strong> Atención inmediata ante accidentes laborales o de trayecto</li>
                <li><strong>Personal Uniformado:</strong> Vestimenta profesional y equipo de radiocomunicación</li>
                <li><strong>Capacitación Continua:</strong> Formación permanente según normativa vigente</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Gestión de Riesgos Operacionales */}
      <section id="gestion-riesgos" className="service-section alt">
        <div className="container">
          <div className="service-content reverse">
            <div className="service-image">
              <img src="/images/risk-management.png" alt="Gestión de Riesgos" />
            </div>
            <div className="service-text">
              <span className="service-badge">Gestión Estratégica</span>
              <h2>Gestión de Riesgos Operacionales</h2>
              <p className="service-intro">Nuestro servicio de gestión de riesgos considera la generación de la matriz de riesgos operacionales de su empresa, identificando los riesgos que pueden afectarla, cuantificamos el impacto que puede producir en la operatividad, su probabilidad de ocurrencia y con ello modelamos controles que disminuyen dicha probabilidad e impacto.</p>
              
              <h3>Proceso en 6 Pasos</h3>
              <div className="process-steps">
                <div className="step">
                  <span className="step-number">1</span>
                  <span className="step-text">Análisis de los procesos</span>
                </div>
                <div className="step">
                  <span className="step-number">2</span>
                  <span className="step-text">Identificación del riesgo</span>
                </div>
                <div className="step">
                  <span className="step-number">3</span>
                  <span className="step-text">Confección de matriz de riesgos</span>
                </div>
                <div className="step">
                  <span className="step-number">4</span>
                  <span className="step-text">Modelamiento de controles</span>
                </div>
                <div className="step">
                  <span className="step-number">5</span>
                  <span className="step-text">Implementación de controles</span>
                </div>
                <div className="step">
                  <span className="step-number">6</span>
                  <span className="step-text">Auditoría de controles</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Auditorías */}
      <section id="auditorias" className="service-section">
        <div className="container">
          <div className="service-content">
            <div className="service-image">
              <img src="/images/audit-service.png" alt="Auditorías" />
            </div>
            <div className="service-text">
              <span className="service-badge">Control y Seguimiento</span>
              <h2>Auditorías</h2>
              <p className="service-intro">Nuestro servicio de auditoría está enfocado en cuantificar el cumplimiento de los sistemas de control y normal funcionamiento operacional presentes e implementados dentro de la empresa.</p>
              
              <h3>Enfoque de Nuestras Auditorías</h3>
              <div className="consulting-services">
                <div className="consulting-item">
                  <h4>Cumplimiento de Sistemas de Control</h4>
                  <p>Cuantificar el cumplimiento de los sistemas de control implementados</p>
                </div>

                <div className="consulting-item">
                  <h4>Funcionamiento Operacional</h4>
                  <p>Cuantificar el normal funcionamiento operacional de la empresa</p>
                </div>

                <div className="consulting-item">
                  <h4>Verificación de Medidas Correctivas</h4>
                  <p>Seguimiento y validación de las acciones correctivas implementadas</p>
                </div>

                <div className="consulting-item">
                  <h4>Rectificación de Falencias</h4>
                  <p>Identificar y corregir aquellas falencias que pongan en riesgo la seguridad y el patrimonio</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Investigación y Prevención de Fraudes */}
      <section id="fraudes" className="service-section alt">
        <div className="container">
          <div className="service-content reverse">
            <div className="service-image">
              <img src="/images/fraud-prevention.png" alt="Prevención de Fraudes" />
            </div>
            <div className="service-text">
              <span className="service-badge">Seguridad Interna</span>
              <h2>Investigación y Prevención de Fraudes</h2>
              <p className="service-intro">Nuestro equipo desarrolla procesos que permiten identificar si se está cometiendo algún fraude al interior de la empresa, creando espacios de verificación, seguimiento de casos vía CCTV, análisis y aplicación de métodos para la obtención de información.</p>
              
              <h3>Metodología</h3>
              <div className="tech-solutions">
                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/verification.png" alt="Verificación" />
                  </div>
                  <div>
                    <h4>Espacios de Verificación</h4>
                    <p>Creación de puntos de control estratégicos para detectar irregularidades</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/cctv-monitoring.png" alt="CCTV" />
                  </div>
                  <div>
                    <h4>Seguimiento vía CCTV</h4>
                    <p>Análisis de video para identificar patrones y comportamientos sospechosos</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/data-analysis.png" alt="Análisis" />
                  </div>
                  <div>
                    <h4>Análisis de Información</h4>
                    <p>Procesamiento de datos y evidencias para determinar la existencia de fraudes</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/investigation.png" alt="Investigación" />
                  </div>
                  <div>
                    <h4>Métodos de Obtención</h4>
                    <p>Aplicación de técnicas profesionales para recopilar información relevante</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Prevención de Pérdidas */}
      <section id="perdidas" className="service-section">
        <div className="container">
          <div className="service-content">
            <div className="service-image">
              <img src="/images/loss-prevention.png" alt="Prevención de Pérdidas" />
            </div>
            <div className="service-text">
              <span className="service-badge">Protección Patrimonial</span>
              <h2>Prevención de Pérdidas</h2>
              <p className="service-intro">Asesoría en prevención de pérdidas, respecto a cómo crear procedimientos que permiten controlar el flujo de activos dentro de una compañía, con el objetivo de maximizar las ganancias.</p>
              
              <h3>Nuestro Servicio Incluye</h3>
              <ul className="advantages-list">
                <li><strong>Análisis de Sistemas de Seguridad:</strong> Evaluación completa de medidas existentes</li>
                <li><strong>Análisis de Procesos Operativos:</strong> Identificación de puntos críticos en la operación</li>
                <li><strong>Identificación de Problemas:</strong> Detección de vulnerabilidades y riesgos</li>
                <li><strong>Corrección de Problemas:</strong> Implementación de soluciones efectivas</li>
                <li><strong>Anticipación de Cambios:</strong> Proyección del impacto de mejoras implementadas</li>
                <li><strong>Toma de Decisiones:</strong> Apoyo para decisiones informadas y estratégicas</li>
              </ul>

              <div className="tech-benefits">
                <h4>Beneficios</h4>
                <ul>
                  <li>Control efectivo del flujo de activos</li>
                  <li>Maximización de ganancias mediante reducción de pérdidas</li>
                  <li>Identificación temprana de irregularidades</li>
                  <li>Mejora continua de procesos operativos</li>
                  <li>Protección del patrimonio empresarial</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Asesorías en Seguridad */}
      <section id="asesoria" className="service-section alt">
        <div className="container">
          <div className="service-content reverse">
            <div className="service-image">
              <img src="/images/consulting-service.jpeg" alt="Asesoría en Seguridad" />
            </div>
            <div className="service-text">
              <span className="service-badge">Consultoría Especializada</span>
              <h2>Asesorías en Seguridad</h2>
              <p className="service-intro">Nuestro servicio de asesoría está enfocado a cuantificar el cumplimiento de los sistemas de control y normal funcionamiento operacional presentes e implementados dentro de la empresa, con el fin de dar un diagnóstico certero para establecer medidas correctivas y rectificar aquellas falencias que pongan en riesgo la seguridad y el patrimonio de la empresa.</p>
              
              <h3>Servicios de Asesoría</h3>
              <div className="consulting-services">
                <div className="consulting-item">
                  <h4>Diagnóstico de Seguridad</h4>
                  <p>Evaluación completa de sistemas de control y funcionamiento operacional</p>
                </div>

                <div className="consulting-item">
                  <h4>Medidas Correctivas</h4>
                  <p>Diseño e implementación de soluciones para falencias identificadas</p>
                </div>

                <div className="consulting-item">
                  <h4>Protección Patrimonial</h4>
                  <p>Estrategias para resguardar los activos de la empresa</p>
                </div>

                <div className="consulting-item">
                  <h4>Cumplimiento Normativo</h4>
                  <p>Asesoría para cumplir con regulaciones y decretos vigentes</p>
                </div>

                <div className="consulting-item">
                  <h4>Optimización de Sistemas</h4>
                  <p>Mejora de procesos de seguridad física y operacional</p>
                </div>

                <div className="consulting-item">
                  <h4>Análisis de Riesgos</h4>
                  <p>Identificación y evaluación de vulnerabilidades críticas</p>
                </div>
              </div>

              <div className="tech-benefits">
                <h4>Estándares que Aplicamos</h4>
                <ul>
                  <li>Normas ISO de gestión de seguridad</li>
                  <li>Leyes y decretos nacionales vigentes</li>
                  <li>Mejores prácticas internacionales</li>
                  <li>Experiencia de más de 30 años en el sector</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tecnología y Proyectos */}
      <section id="tecnologia" className="service-section">
        <div className="container">
          <div className="service-content">
            <div className="service-image">
              <img src="/images/technology-service.png" alt="Tecnología y Proyectos" />
            </div>
            <div className="service-text">
              <span className="service-badge">Tecnología Avanzada</span>
              <h2>Tecnología y Proyectos</h2>
              <p className="service-intro">Implementación de soluciones tecnológicas para complementar y potenciar las medidas de seguridad física, con proyectos de monitoreo remoto y sistemas de control avanzados.</p>
              
              <h3>Soluciones Tecnológicas</h3>
              <div className="tech-solutions">
                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/cctv-system.png" alt="CCTV" />
                  </div>
                  <div>
                    <h4>Control CCTV con Analistas</h4>
                    <p>Monitoreo profesional con personal capacitado para análisis en tiempo real</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/remote-monitoring.png" alt="Monitoreo Remoto" />
                  </div>
                  <div>
                    <h4>Proyectos de Monitoreo Remoto</h4>
                    <p>Sistemas de vigilancia y control accesibles desde cualquier ubicación</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/access-control.png" alt="Control de Acceso" />
                  </div>
                  <div>
                    <h4>Sistemas de Control de Acceso</h4>
                    <p>Gestión inteligente de entrada y salida de personas</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/integration.png" alt="Integración" />
                  </div>
                  <div>
                    <h4>Integración de Sistemas</h4>
                    <p>Conexión de múltiples plataformas de seguridad en un solo sistema</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/radio-communication.png" alt="Radiocomunicación" />
                  </div>
                  <div>
                    <h4>Radiocomunicación</h4>
                    <p>Equipos de comunicación profesional para coordinación operativa</p>
                  </div>
                </div>

                <div className="tech-item">
                  <div className="tech-icon">
                    <img src="/images/icons/reports.png" alt="Reportes" />
                  </div>
                  <div>
                    <h4>Análisis y Reportes</h4>
                    <p>Generación de informes detallados de eventos y actividades</p>
                  </div>
                </div>
              </div>

              <div className="tech-benefits">
                <h4>Beneficios de la Integración Tecnológica</h4>
                <ul>
                  <li>Mayor eficiencia en la detección y respuesta ante incidentes</li>
                  <li>Registro digital de eventos para análisis y auditoría</li>
                  <li>Reducción de costos operativos a largo plazo</li>
                  <li>Monitoreo continuo 24/7 con soporte profesional</li>
                  <li>Escalabilidad según necesidades de crecimiento</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <h2>¿Listo para Mejorar tu Seguridad?</h2>
          <p>Contáctanos para una evaluación gratuita y descubre la solución perfecta para ti</p>
          <Link to="/contacto" className="btn btn-primary">Solicitar Cotización</Link>
        </div>
      </section>
    </div>
  );
}

export default Services;